<template>
	<div class="service-box" v-show="show">
		<div class="layer-wrap" v-show="showType == 'wechat' || showType == 'phone'" @click="hide">
			<div class="layer-mask"></div>
			<div class="layer-content">
				<div class="card" v-show="showType == 'wechat'">
					<div class="text-bold" style="font-size: 18px;">微信咨询</div>
					<img class="img" :src="setting.contact_qr_code || '../assets/images/service/qr@2x.jpg' " style="width: 150px;height: 150px;" />
					<div style="font-size: 15px;">手机扫码加我微信</div>
				</div>
				<div class="card" v-show="showType == 'phone'">
					<div class="text-bold" style="font-size: 18px;">电话咨询</div>
					<img class="img" :src="setting.contact_qr_code || '../assets/images/service/qr@2x.jpg' " style="width: 150px;height: 150px;" />
					<div style="font-size: 12px;text-align: left;margin-left: 10px;">咨询（9:00-18:00）</div>
					<div style="font-size: 12px;text-align: left;margin-left: 10px;">商家服务：{{ setting.contact_tel }}</div>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="item" v-if="!!setting.contact_qr_code" @click.stop="changeType('wechat')">
				<img src="../assets/images/service/wechat@2x.png" style="width: 26px;height: 21px;" />
				<div class="text">微信咨询</div>
			</div>
			<div class="item" v-if="!!setting.contact_tel" @click.stop="changeType('phone')">
				<img src="../assets/images/service/phone@2x.png" style="width: 17px;height: 24px;" />
				<div class="text">电话咨询</div>
			</div>
		</div>

	</div>

</template>

<script>
	import {
		mapState
	} from 'vuex';

	export default {
		name: 'SideService',
		components: {

		},
		computed: {
			...mapState([ "setting"]),

		},

		data() {
			return {
				showType: '',
				show:true
			};
		},
		watch: {
			$route(to) {
				if(to.name == 'Login' || to.name == 'Design') {
					this.show = false
				} else {
					this.show = true
				}
			},
		},
		methods: {
			changeType(type) {
				this.showType = type
			},
			hide() {
				this.showType = ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.service-box {


		.item {
			width: 68px;
			height: 68px;
			background: #E6E6EC;
			border-radius: 6px;
			margin-bottom: 10px;
			text-align: center;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			cursor: pointer;
			z-index: 9999;

			.text {
				font-size: 13px;
				color: #0F114A;
				margin-top: 5px;
			}
		}

		.card {
			width: 190px;
			// height: 256px;
			background: #FFFFFF;
			box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.16);
			border-radius: 6px;
			color: #0F114A;
			text-align: center;
			padding: 20px 0;
			.img{
				margin: 10px 0;
			}
			.text-bold{
				font-weight: bold;
			}
		}
	}
	.right{
		position: fixed;
		right: 20px;
		top: 400px;
		z-index: 9999;
	}

	.layer-wrap,
	.layer-wrap .layer-mask {
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.layer-wrap {
		z-index: 10;
		position: fixed;
	}

	.layer-wrap .layer-mask {
		z-index: 3;
		position: absolute;
	}

	.layer-wrap .layer-content {
		position: fixed;
		top: 400px;
		z-index: 9;
		right: 110px;

	}
</style>
